import React, { useState } from 'react'
import { img } from '../assets/assets'

const Team = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false)
    return (
        <>
            <div className="overflow-hidden">
                {/* <!-- <div className="bg-dark py-10">
            <div className="container">
                <div
                    className="text-center
                    d-flex
                    justify-content-between
                    space-x-10
                    align-items-center">
                    <div className="space-x-10 d-flex align-items-center">
                        <lottie-player
                            src="https://assets6.lottiefiles.com/private_files/lf30_kqshlcsx.json"
                            background="transparent"
                            speed="2"
                            style="width: 50px; height: 50px"
                            loop
                            autoplay></lottie-player>
                        <p className="color_white">
                            <span style="color: rgb(0, 255, 170)">Switch </span>
                            to Dark Mode?
                        </p>
                    </div>

                    <div className="mode_switcher space-x-10">
                        <a href="#" className="light d-flex align-items-center is_active">
                            <i className="ri-sun-fill"></i> Light
                        </a>
                        <a href="#" className="dark d-flex align-items-center">
                            <i className="ri-moon-fill"></i> Dark
                        </a>
                    </div>
                </div>
            </div>
        </div> --> */}

                <header className="header__1 js-header" id="header">
                    <div className="container">
                        <div className="wrap js-header-wrapper">
                            <div className="header__logo">
                                <a className="color_black" href="/">
                                    <img
                                        src={img.logos_seducetoken}
                                        alt="logo"
                                        id="logo_js_f"
                                    />
                                </a>
                            </div>

                            {/* <!-- ==================  --> */}
                            <div className="header__menu">
                                <ul className="d-flex space-x-20">
                                    <li className="has_popup">
                                        <a className="color_black" href="/">
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/about"
                                        >
                                            About Us
                                        </a>
                                    </li>
                                    <li>
                                        <a className="color_black" href="/team">
                                            Our Team
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href={img.whitepaper}
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/ambassador"
                                        >
                                            Ambassadors
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/contact"
                                        >
                                            Contact
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* <!-- ================= --> */}
                            <div className="header__btns">
                                <a
                                    className="btn btn-grad btn-sm"
                                    href="/dashboard"
                                >
                                    <img
                                        src={img.icons_settings}
                                        alt="Dashboard"
                                        height="20px"
                                        width="20px"
                                    />
                                    Dashboard
                                </a>
                            </div>

                            <div
                                className="header__burger js-header-burger"
                                onClick={() =>
                                    setShowMobileMenu(!showMobileMenu)
                                }
                            ></div>
                            {showMobileMenu ? (
                                <div className="header__mobile js-header-mobile">
                                    <div className="header__mobile__menu space-y-40">
                                        <ul className="d-flex space-y-20">
                                            <li className="has_popup">
                                                <a
                                                    className="color_black"
                                                    href="/"
                                                >
                                                    Home
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/about"
                                                >
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/team"
                                                >
                                                    Our Team
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/roadmap"
                                                >
                                                    Roadmap
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href={img.whitepaper}
                                                >
                                                    Whitepaper
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/ambassador"
                                                >
                                                    Ambassadors
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    className="color_black"
                                                    href="/contact"
                                                >
                                                    Contact
                                                </a>
                                            </li>
                                        </ul>
                                        <div className="space-y-20">
                                            <a
                                                className="btn btn-grad btn-sm"
                                                href="/dashboard"
                                            >
                                                Dashboard
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </header>

                <div className="hero__creators">
                    <div className="container">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-lg-6">
                                <div className="space-y-20">
                                    <h1>Our Team</h1>
                                    <p className="hero__text">
                                        Meet the creative personalities behind
                                        the making of Seduce Token.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 cardpadding">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.avatar_jack}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">1</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Jack <br /> [KYC Verified]
                                        </p>
                                        <span className="sales color_text">
                                            Singapore
                                        </span>
                                        <br />
                                        <span className="sales color_text">
                                            CEO
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.avatar_kyle}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">2</div>
                                    </div>
                                    <div className="text-center kylecard">
                                        <p className="avatars_name large color_black">
                                            Kyle <br /> [Doxxed]
                                        </p>
                                        <span className="sales color_text">
                                            USA
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.avatar_ds}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">3</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            DS <br /> [Doxxed]
                                        </p>
                                        <span className="sales color_text">
                                            USA
                                        </span>
                                        <br />
                                        <span className="sales color_text">
                                            Public Relations
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <img
                                            src={img.avatar_chris_PFP}
                                            alt="Avatar"
                                            className="avatar avatar-md"
                                        />
                                        <div className="has_number">4</div>
                                    </div>
                                    <div className="text-center">
                                        <p className="avatars_name large color_black">
                                            Chris <br /> [Doxxed]
                                        </p>
                                        <span className="sales color_text">
                                            UK
                                        </span>
                                        <br />
                                        <span className="sales color_text">
                                            Community Lead
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-3">
                            <div className="creator_item creator_card space-y-10 is_big">
                                <div className="avatars flex-column space-y-10">
                                    <div className="media has_border">
                                        <a href="https://queenpius70.wixsite.com/website">
                                            <img
                                                src={img.avatar_avatar3}
                                                alt="Avatar"
                                                className="avatar avatar-md"
                                            />
                                        </a>
                                        <div className="has_number">5</div>
                                    </div>
                                    <div className="text-center">
                                        <a href="https://queenpius70.wixsite.com/website">
                                            <p className="avatars_name large color_black">
                                                McQueen <br /> [Doxxed]
                                            </p>
                                        </a>
                                        <span className="sales color_text">
                                            Nigeria
                                        </span>
                                        <br />
                                        <span className="sales color_text">
                                            Graphics Lead
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer className="footer__1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 space-y-20">
                                <div className="footer__logo">
                                    <a href="/">
                                        <img
                                            src={img.logos_seducetoken}
                                            alt="logo"
                                            id="logo_js_f"
                                        />
                                    </a>
                                </div>

                                <div>
                                    <ul className="footer__social space-x-10 mb-40">
                                        <li>
                                            <a href="https://instagram.com/seduce_token_official?utm_medium=copy_link">
                                                <i className="ri-instagram-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://twitter.com/seducetokenbsc">
                                                <i className="ri-twitter-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://discord.gg/ewekBsfU4B">
                                                <i className="ri-discord-line"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://t.me/seducetokenofficial">
                                                <i className="ri-telegram-line"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Project</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/"> Home </a>
                                    </li>
                                    <li>
                                        <a href="/about">About us</a>
                                    </li>
                                    <li>
                                        <a href="/team"> Our Team</a>
                                    </li>
                                    <li>
                                        <a
                                            className="color_black"
                                            href="/roadmap"
                                        >
                                            Roadmap
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/ambassador">Ambassadors</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Get help</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a href="/contact">Contact Us</a>
                                    </li>
                                    <li>
                                        <a href="/dashboard" target="_blank">
                                            Buy Token
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div className="col-lg-2 col-6">
                                <h6 className="footer__title">Documents</h6>
                                <ul className="footer__list">
                                    <li>
                                        <a
                                            href={img.whitepaper}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Whitepaper
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <p className="copyright text-center">
                            © Seduce Token 2021. Created with love by
                            <a
                                href="https://theclusterco.com"
                                target="_blank"
                                rel="noreferrer"
                            >
                                TheCluster
                            </a>
                            .
                        </p>
                    </div>
                </footer>
            </div>
        </>
    )
}

export default Team
